<template>
  <div class="page-header align-items-start min-vh-100 mbr-reset">
    <span class="mask bg-white"></span>

    <div class="notifications">
      <material-alert
        v-if="error"
        color="danger"
        icon="ni ni-like-2 ni-lg"
        dismissible
      >
        {{ error }}
      </material-alert>
    </div>

    <section class="mbr-reset__step">
      <div class="mbr-reset__body">
        <div class="mbr-reset__tile">
          <img v-if="$store.state.merchantLogo" :src="$store.state.merchantLogo" :alt="$t('home.merchant_logo')" />
          <img v-else src="../assets/img/logo.png" :alt="$t('home.merchant_logo')" />
        </div>

        <template v-if="isValidLink">
          <template v-if="isNewPassword">
            <h1 class="mbr-reset__title">{{ $t('forgot.create_new') }}</h1>
            <div id="otp" class="mbr-reset__pin">
              <passcode-pin
                ref="inputNewPassword"
                :should-auto-focus="true"
                :aria-label="$t('passcode.new_passcode')"
                @on-change="handleOnChange"
                @on-complete="handleOnCompleteNewPassword"
                v-model="newPassword"
              />
            </div>
          </template>

          <template v-if="isNewPasswordAgain">
            <h1 class="mbr-reset__title">{{ $t('forgot.confirm_new') }}</h1>
            <div id="otp" class="mbr-reset__pin">
              <passcode-pin
                ref="inputNewPasswordAgain"
                :should-auto-focus="true"
                :aria-label="$t('passcode.confirm_new_passcode')"
                @on-change="handleOnChange"
                @on-complete="handleOnCompleteNewPasswordAgain"
                v-model="newPasswordAgain"
              />
            </div>
          </template>

          <template v-if="isUpdateSuccess">
            <span class="mbr-reset__icon" aria-hidden="true">
              <i class="material-icons-round">check</i>
            </span>
            <h1 class="mbr-reset__title mbr-reset__title--sm">{{ $t('forgot.changed') }}</h1>
            <material-button size="lg" full-width @click="redirectToSignIn()">{{ $t('forgot.login') }}</material-button>
          </template>
        </template>

        <template v-else-if="messageInvalidLink">
          <span class="mbr-reset__icon mbr-reset__icon--error" aria-hidden="true">
            <i class="material-icons-round">link_off</i>
          </span>
          <p class="mbr-reset__message">{{ messageInvalidLink }}</p>
        </template>
      </div>

      <passcode-keypad v-if="isValidLink && (isNewPassword || isNewPasswordAgain)" class="mbr-reset__keypad" />
    </section>

    <div class="position-fixed top-1 end-1 z-index-2" style="z-index: 10001 !important;">
      <material-snackbar v-if="snackbar === 'danger' || snackbar === 'success'" title="" date=""
                :description="message" :icon="{ component: 'campaign', color: 'white' }" :color="snackbar"
                :close-handler="closeSnackbar" />
    </div>
    <material-loading :active="loaderActive" />
  </div>
</template>

<script>
import MaterialAlert from "@/components/MaterialAlert.vue";
import { mapMutations } from "vuex";
import MaterialSnackbar from "@/components/MaterialSnackbar.vue";
import MaterialLoading from "@/components/MaterialLoading.vue";
import PasscodePin from "@/components/PasscodePin.vue";
import PasscodeKeypad from "@/components/PasscodeKeypad.vue";
import MaterialButton from "@/components/MaterialButton.vue";
// import { useRoute } from 'vue-router'
import { ref } from "vue";
import AuthService from "../services/auth.service";
import store from "@/store";
import { errorMessage } from "@/utils/errorMessage";

export default {
  name: "sign-in",
  components: {
    MaterialAlert,
    MaterialSnackbar,
    PasscodePin,
    PasscodeKeypad,
    MaterialLoading,
    MaterialButton
  },
  setup() {
    const inputOTP = ref(null);

    const clearInputOTP = () => {
      inputOTP.value.clearInput();
    };
    return { inputOTP, clearInputOTP };
  },
  data() {
    return {
      message: "",
      snackbar: null,
      error: "",
      valueNewPassword: '',
      valueNewPasswordAgain: '',
      isNewPassword: true,
      isNewPasswordAgain: false,
      isUpdateSuccess: false,
      timerEnabled: true,
      merchantCode: "",
      loaderActive: false,
      isValidLink: false,
      messageInvalidLink: '',
    };
  },
  beforeMount() {
    this.toggleEveryDisplay();
    this.toggleHideConfig();
  },
  beforeUnmount() {
    this.toggleEveryDisplay();
    this.toggleHideConfig();
  },
  mounted() {
    const code = this.$router.currentRoute.value.params.merchant_code ?? "";
    store.dispatch('setMerchantCode', code);
    localStorage.setItem('MERCHANT_CODE_' + code, code)
    this.merchantCode = code ? `/${code}` : "";
    // const token = TokenService.getLocalAccessToken();
    // const route = useRoute()
    this.validateLinkForgetPasscodeByCode();
  },
  methods: {
    ...mapMutations(["toggleEveryDisplay", "toggleHideConfig"]),
    closeSnackbar() {
      this.snackbar = null;
    },
    setTimeOutNotification() {
      setTimeout(() => {
        this.snackbar = null;
      }, 3000);
    },
    showLoader() {
      this.loaderActive = true;
    },
    hideLoader() {
      this.loaderActive = false;
    },
    handleOnCompleteNewPassword: function (value) {
      this.valueNewPassword = value;
      this.isNewPassword = false;
      this.isNewPasswordAgain = true;
    },
    handleOnCompleteNewPasswordAgain: function (value) {
      this.closeSnackbar()
      this.showLoader()
      AuthService.updatePasscode(this.$route.query.code, value).then(
        (response) => {
          if (response.data.result.isSuccess) {
            this.isNewPassword = false;
            this.isNewPasswordAgain = false;
            this.isUpdateSuccess = true;
          } else {
            this.snackbar = 'danger'
            this.message = errorMessage(response.data.result.message)
            this.setTimeOutNotification()
          }
          this.hideLoader()
        },
        (error) => {
          this.snackbar = 'danger'
          this.message = errorMessage(error)
          this.hideLoader()
        }
      )
    },
    redirectToSignIn() {
      this.$router.push({ path: this.merchantCode + "/sign-in" });
    },
    validateLinkForgetPasscodeByCode() {
      this.closeSnackbar()
      this.showLoader()
      AuthService.validateLinkForgetPasscodeByCode(this.$route.query.code).then(
        (response) => {
          if (response.data.result.isSuccess) {
            this.messageInvalidLink = '';
            this.isValidLink = true;
          } else {
            this.messageInvalidLink = errorMessage(response.data.result.message);
            this.isValidLink = false;
          }
          this.hideLoader()
        },
        (error) => {
          this.snackbar = 'danger'
          this.message = errorMessage(error)
          this.hideLoader()
        }
      )
    }
  },
};
</script>
<style scoped>
/* MBR016 Heritage Hearth reset-link page — mirrors the SignIn passcode steps */
/* Unscoped `* { font-family: Poppins }` in Landing / Store / RewardCatalogue hits every element;
   :where() keeps this at one attribute's specificity so class rules (titles, buttons) still win */
:where(:not(.material-icons-round)) {
  font-family: var(--mbr-font-body);
}

.mbr-reset.page-header {
  flex-direction: column;
  font-family: var(--mbr-font-body);
}

.mbr-reset__step {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 440px;
  min-height: 100vh;
  min-height: 100dvh;
  margin: 0 auto;
  padding: 24px 24px 40px;
  background: var(--mbr-color-canvas);
  /* Passcode screens keep the design canvas; brand colours follow the theme tokens (MBR128) */
  --mbr-color-canvas: #FFF8F7;
}

.mbr-reset__body {
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 24px;
  padding: 32px 0;
  text-align: center;
}

.mbr-reset__keypad {
  flex: none;
}

.mbr-reset__tile {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  padding: 8px;
  background: var(--mbr-color-primary);
  border-radius: var(--mbr-radius-lg);
  box-shadow: var(--mbr-shadow-card);
}

.mbr-reset__tile img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  border-radius: var(--mbr-radius);
}

/* font-family/color set explicitly: Material Dashboard forces Roboto Slab on h1-h3 */
.mbr-reset__title {
  margin: 0;
  font-family: var(--mbr-font-headline);
  font-size: 28px;
  font-weight: 800;
  line-height: 1.2;
  letter-spacing: -0.02em;
  color: var(--mbr-color-ink-headline);
}

.mbr-reset__title--sm {
  font-size: var(--mbr-headline-md-size);
  line-height: var(--mbr-headline-md-line);
}

.mbr-reset__pin {
  display: flex;
  justify-content: center;
}

.mbr-reset__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 72px;
  height: 72px;
  background: var(--mbr-color-surface);
  border: 1px solid var(--mbr-color-outline);
  border-radius: var(--mbr-radius-full);
  box-shadow: var(--mbr-shadow-card);
  color: var(--mbr-color-positive);
}

.mbr-reset__icon .material-icons-round {
  font-size: 40px;
}

.mbr-reset__icon--error {
  background: var(--mbr-color-error-container);
  border-color: transparent;
  color: var(--mbr-color-error);
}

.mbr-reset__message {
  max-width: 320px;
  margin: 0;
  font-size: var(--mbr-body-md-size);
  font-weight: 600;
  line-height: var(--mbr-body-md-line);
  color: var(--mbr-color-ink-secondary);
}
</style>
